import React from "react";
import { useLang } from "@/contexts/LangContext";

export default function LangSwitcher({ size = "sm" }) {
  const { lang, setLang, languages } = useLang();
  const px = size === "lg" ? "px-3 py-2 text-xs" : "px-2.5 py-1.5 text-[11px]";

  return (
    <div
      className="inline-flex items-center border border-white/15 divide-x divide-white/10"
      data-testid="lang-switcher"
    >
      {languages.map((l) => (
        <button
          key={l.code}
          onClick={() => setLang(l.code)}
          data-testid={`lang-${l.code}`}
          aria-pressed={lang === l.code}
          className={`${px} tracking-[0.18em] uppercase font-medium transition-colors ${
            lang === l.code
              ? "bg-white text-[#051630]"
              : "text-white/60 hover:text-white"
          }`}
        >
          {l.label}
        </button>
      ))}
    </div>
  );
}
